import * as React from "react";
import { observer, inject } from "mobx-react";
import { action, observable } from "mobx";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { ScreenMode, SavedOpportunityState } from "../../../models/enums";
import { ILocalization } from "../../../models/localization";
import { SavedOpportunity } from "../../../models/profile";
import { Opportunity } from "../../../models/opportunity";
import OpportunityStore from "../../../stores/opportunityStore";
import ProfileStore from "../../../stores/profileStore";
import { Row, Col } from "react-flexbox-grid";
import { TabsHorizontal } from "../tabsHorizontal";
import IconButton from "material-ui/IconButton";
import ArrowButton from "material-ui-icons/ArrowBack";
import Button from "material-ui/Button";
import BackArrow from "../../widgets/backBtn";
import { Education } from "../educationSlider";
import Tooltip from 'material-ui/Tooltip';
import * as s from "./headerImg.css";

interface IParams {
  opId: string;
}

@observer
export class HeaderDesktop extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  private _profStore: ProfileStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
    this._profStore = this.props.store.profileStore;
  }
  handleApply = (hasApplied: boolean): void => {
    if (!hasApplied) {
      const func: (op?: Opportunity) => void = this.props.store.opportunityStore.getApplicationFunction();
      func();
    } else {
      this.props.store.viewState.setShowConfirmationDlg(true);
    }
  }

  render(): JSX.Element {  
    const local: ILocalization = this.props.store.localization.fields;
    const imgUrl: string = "../image/" + this._opStore.selectedOp.imageId;
    const savedOp = this._profStore.getSavedOpportunity(this.props.params.opId);
    if (!savedOp) { return null; }
    const isSaved: boolean = savedOp && (savedOp.status & SavedOpportunityState.Saved) > 0;
    const hasApplied = (savedOp.status & SavedOpportunityState.Applied) > 0;   

    const styles: any = {
      button: {
        position: "absolute",
        bottom: "5%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        }
    }
    return (<Col xs={12} sm={8} md={8} >
      <div className={s.outerBox}>
        <img className={s.opsImgDesktop} src={imgUrl} />
        <div className={s.innerBox}></div>
        <div className={s.onTop}>
          <Row>
            <Col xs={1}> <IconButton style={styles.MuiIconButton} aria-label="arrow-back" onClick={() => hashHistory.goBack()}><ArrowButton /></IconButton></Col>   
            {isSaved && <Col xs={1}><img className={s.starredIcon} src={local.icons.yellowStar} /></Col>}
            {!isSaved && <Col xs={1}><img className={s.starredIcon} src={local.icons.whiteStar} /></Col>}
            <Col xs={8}></Col>
            <Col xs={2}><div className={s.badgeRibbon}><div className={s.desktopScore}><h2>{savedOp && !isNaN(savedOp.fit) ? savedOp.fit : null}</h2><p>{local.opportunity.skillScore}</p></div></div></Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className={s.imgTextWrapper}>
                <p className={s.smallText}>{this._opStore.selectedOp.category}</p>
                <h3 className={s.opTitle}>{this._opStore.selectedOp.name}</h3>
              </div>
              {this._opStore.selectedOp.description === null && <div className={s.descNotAvailable}><p>{local.noDescription}</p></div>}
              <div className={s.scrollableContent}>
                {this._opStore.selectedOp.postedBy !== null && <div className={s.opEmployer}><p>{`${local.opportunity.employer}: ${this._opStore.selectedOp.postedBy}`}</p></div>}
                <div className={s.opDescription} dangerouslySetInnerHTML={{ __html: this._opStore.selectedOp.description }}></div>
              </div>        
            </Col>
          </Row>
          {this._opStore.selectedOp && this._opStore.selectedOp.allowApply && <Button raised style={styles.button} color="secondary" className={s.ssApplyButton} onClick={() => this.handleApply(hasApplied)} ><p className={s.smallText}>{local.apply}</p></Button>}
        </div>
      </div>
    </Col>)
  }
}

@observer
export class HeaderTablet extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  private _profStore: ProfileStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
    this._profStore = this.props.store.profileStore;
  }

  handleApply = (): void => {
    const func: (op?: Opportunity) => void = this._opStore.getApplicationFunction();
    func();
  }
  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const local: ILocalization = this.props.store.localization.fields;
    const imgUrl: string = "../image/" + this._opStore.selectedOp.imageId;
    const savedOp = this._profStore.getSavedOpportunity(this.props.params.opId);
    if (!savedOp) { return null; }
    const isSaved: boolean = savedOp && (savedOp.status & SavedOpportunityState.Saved) > 0;
    const hasApplied = (savedOp.status & SavedOpportunityState.Applied) > 0;

    const styles: any = {
      button: {
        position: "absolute",
        bottom: "10%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }
    }

    return (<Row className={s.container}><Col xs={12}>
      <div className={s.outerBox}>
        <img className={s.opsImg} src={imgUrl} />
        <div className={s.innerBox}></div>
        <div className={s.onTop}>
          <Row>
            <Col xs={1}> <IconButton style={styles.MuiIconButton} aria-label="arrow-back" onClick={() => hashHistory.goBack()}><ArrowButton /></IconButton></Col>
            {isSaved && <Col xs={1}><img className={s.starredIcon} src={local.icons.yellowStar} /></Col>}
            {!isSaved && <Col xs={1}><img className={s.starredIcon} src={local.icons.whiteStar} /></Col>}
            <Col xs={8}></Col>
            <Col xs={2}><div className={s.badgeRibbon}><div className={s.desktopScore}><h2>{savedOp && !isNaN(savedOp.fit) ? savedOp.fit : null}</h2><p>{local.opportunity.skillScore}</p></div></div></Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className={s.imgTextWrapper}>
                <p className={s.smallText}>{this._opStore.selectedOp.category}</p>
              </div>
            </Col>
          </Row>
          <Row className={s.titleRow}>
            <Col xs={12} className={s.titleCol}>
              <h2 className={s.centerTitle}>{this._opStore.selectedOp.name}</h2>
            </Col>
          </Row>
          {this._opStore.selectedOp && this._opStore.selectedOp.allowApply && <Button raised style={styles.button} color="secondary" aria-label={local.apply} className={s.ssApplyButton}
            onClick={this.handleApply}><p className={s.smallText}>{local.apply}</p></Button>}
        </div>
      </div>
    </Col></Row>)
  }
}

@observer
export class HeaderMobile extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  private _profStore: ProfileStore;
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
    this._profStore = this.props.store.profileStore;
  }

  handleApply = (): void => {
    const func: (op?: Opportunity) => void = this._opStore.getApplicationFunction();
    func();
  }
  render(): JSX.Element {
   
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const local: ILocalization = this.props.store.localization.fields;
    const imgUrl: string = "../image/" + this._opStore.selectedOp.imageId;
    const savedOp = this._profStore.getSavedOpportunity(this.props.params.opId);
    if (!savedOp) { return null; }
    const isSaved: boolean = savedOp && (savedOp.status & SavedOpportunityState.Saved) > 0;
    const hasApplied = (savedOp.status & SavedOpportunityState.Applied) > 0;

    const styles: any = {
      button: {
        position: "absolute",
        bottom: "10%",
        left: "50%",
        width: "60%",
        transform: "translate(-50%, -50%)",
      }
    }

    return (<Row><Col xs={12} >
      <div className={s.outerBox}>
        <img className={s.opsImg} src={imgUrl} />
        <div className={s.innerBox}></div>
        <div className={s.onTop}>
         <Row className={s.mobileRow}>
            <Col xs={2}> <IconButton style={styles.MuiIconButton} aria-label="arrow-back" onClick={() => hashHistory.goBack()}><ArrowButton /></IconButton></Col>         
            {isSaved && <Col xs={1}><img className={s.starredIcon} src={local.icons.yellowStar} /></Col>}
            {!isSaved && <Col xs={1}><img className={s.starredIcon} src={local.icons.whiteStar} /></Col>}
            <Col xs={5}></Col>
            <Col xs={3}><div className={s.badgeRibbonSmall}><div className={s.desktopScoreMobile}><h3>{savedOp && !isNaN(savedOp.fit) ? savedOp.fit : null}</h3><p>{local.opportunity.skillScore}</p></div></div></Col> 
          </Row>
          <Row>
            <Col xs={12}>
              <div className={s.imgTextWrapper}>
             <p className={s.smallTextMobile}>{this._opStore.selectedOp.category}</p>
              </div>
            </Col>
          </Row>
          <Row className={s.titleRow}>
            <Col xs={12} className={s.titleCol}>
              <h4 className={s.centerTitle}>{this._opStore.selectedOp.name}</h4>
            </Col>
          </Row>
          {this._opStore.selectedOp && this._opStore.selectedOp.allowApply && <Button raised style={styles.button} color="secondary" aria-label={local.apply} className={s.ssApplyButton}
           onClick={this.handleApply}><p className={s.smallTextMobile}>{local.apply}</p></Button>}
        </div>
      </div>
    </Col></Row>)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/headerImg/index.tsx